<template>
  <b-modal ref="modal" :title="this.$t('cloud-status') | capitalize" ok-only :ok-title="$t('close')">
    <b-overlay :show="!isOnline" blur="10px" bg-color="white">

      <template v-slot:overlay>
        <h2 class="text-center">No internet connection</h2>
      </template>

      <b-row class="justify-content-center">
        <b-col cols="4">
          <icool-icon :icon="cloudStatusIcon" />
        </b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="4" :style="{'border-right': '2px solid', height: '2rem'}"></b-col>
        <b-col cols="4"></b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="3" :style="{'border-right': '2px solid', 'border-left': '2px solid', 'border-top': '2px solid', height: '2rem'}"></b-col>
        <b-col cols="3" :style="{'border-right': '2px solid', 'border-top': '2px solid', height: '2rem'}"></b-col>
        <b-col cols="3" :style="{'border-right': '2px solid', 'border-top': '2px solid', height: '2rem'}"></b-col>
      </b-row>
      <b-row class="justify-content-center">
        <b-col cols="3">
          <div class="d-flex justify-content-center text-black-50">
            <font-awesome-icon icon="server" size="2x" />
            <font-awesome-icon
              transform="up-6 left-6"
              :icon="comsStatusIcon"
              size="lg"
              :style="{position: 'absolute', top: 0, left: 80 }"
              :class="[isCOMSok ? 'text-success' : 'text-danger']"
            />
          </div>
          <div class="d-flex justify-content-center">
            Coms
          </div>
        </b-col>
        <b-col cols="3">
          <div class="d-flex justify-content-center text-black-50">
            <font-awesome-icon icon="ethernet" size="2x" />
            <font-awesome-icon
              transform="up-6 left-6"
              :icon="vpnStatusIcon"
              size="lg"
              :style="{position: 'absolute', top: 0, left: 80 }"
              :class="[isVPNok ? 'text-success' : 'text-danger']"
            />
          </div>
          <div class="d-flex justify-content-center">
            VPN
          </div>
        </b-col>
        <b-col cols="3">
          <div class="d-flex justify-content-center text-black-50">
            <font-awesome-icon icon="microchip" size="2x" />
            <font-awesome-icon
              transform="up-6 left-6"
              :icon="plcStatusIcon"
              size="lg"
              :style="{position: 'absolute', top: 0, left: 80 }"
              :class="[isPLCok ? 'text-success' : 'text-danger']"
            />
          </div>
          <div class="d-flex justify-content-center">
            PLC
          </div>
        </b-col>
        <b-col cols="3">
          <div class="d-flex justify-content-center text-black-50">
            <font-awesome-icon icon="wifi" size="2x" />
            <font-awesome-icon
              transform="up-6 right-10"
              :icon="wsStatusIcon"
              size="lg"
              :style="{position: 'absolute', top: 0, left: 60 }"
              :class="[isWSok ? 'text-success' : 'text-danger']"
            />
          </div>
          <div class="d-flex justify-content-center">
            WS
          </div>
        </b-col>
      </b-row>

    <p class="text-center mt-5">
      <strong>{{ $t('snapshot-build-datetime') }}</strong>
    </p>
    <p class="text-center ">{{ snapshotBuildDT }}</p>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'CloudStatusModal',
  computed: {
    ...mapState('app', [
      'cloudStatus',
      'isOnline',
    ]),
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    ...mapGetters('app', [
      'isConnectionOk',
      'isPLCok',
      'isCOMSok',
      'isVPNok',
      'isWSok',
    ]),
    cloudStatusIcon() {
      if (this.isConnectionOk) {
        return 'connection-ok';
      }
      return 'connection-fail';
    },
    vpnStatusIcon() {
      return this.getStatusIcon(this.isVPNok);
    },
    comsStatusIcon() {
      return this.getStatusIcon(this.isCOMSok);
    },
    wsStatusIcon() {
      return this.getStatusIcon(this.cloudStatus.status_ws);
    },
    plcStatusIcon() {
      return this.getStatusIcon(this.isPLCok);
    },
    snapshotBuildDT() {
      if (this.currentSnapshot) {
        return moment(this.currentSnapshot.ctime).format('LLL');
      }
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    getStatusIcon(status) {
      return status ? 'check-circle' : 'times-circle';
    },
  },
};
</script>

<style scoped>

</style>
